export const ACTIVE_WORKSPACE_STORAGE_KEY = "mkt_workspace_id";

export const WORKSPACE_HEADER_KEY = "X-Marketing-Workspace-Id";

type WorkspaceListener = (workspaceId: string | null) => void;

const listeners = new Set<WorkspaceListener>();

export function getActiveWorkspaceId(): string | null {
  try {
    return localStorage.getItem(ACTIVE_WORKSPACE_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setActiveWorkspaceId(workspaceId: string | null): void {
  try {
    if (workspaceId) {
      localStorage.setItem(ACTIVE_WORKSPACE_STORAGE_KEY, workspaceId);
    } else {
      localStorage.removeItem(ACTIVE_WORKSPACE_STORAGE_KEY);
    }
  } catch {
    // noop
  }

  listeners.forEach((listener) => listener(workspaceId));
}

export function subscribeToActiveWorkspace(listener: WorkspaceListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getWorkspaceHeader(): Record<string, string> {
  const workspaceId = getActiveWorkspaceId();
  return workspaceId ? { [WORKSPACE_HEADER_KEY]: workspaceId } : {};
}
